/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiCaricamentoMultimedialeGdriveParentidFolderGet$Params {
    /**
     * Corpo per cui caricare la folder
     */
    corpoId: number;
}

export function apiCaricamentoMultimedialeGdriveParentidFolderGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiCaricamentoMultimedialeGdriveParentidFolderGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(rootUrl, apiCaricamentoMultimedialeGdriveParentidFolderGet.PATH, 'get');
    if (params) {
        rb.query('corpoId', params.corpoId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<string>;
        }),
    );
}

apiCaricamentoMultimedialeGdriveParentidFolderGet.PATH = '/api/caricamento-multimediale/gdrive-parentid-folder';
